"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var withOne_exports = {};
__export(withOne_exports, {
  default: () => withOne_default,
  withOne: () => withOne
});
module.exports = __toCommonJS(withOne_exports);
var import_path = __toESM(require("path"), 1);
var import_vite_plugin_metro = require("@vxrn/vite-plugin-metro");
var import_getViteMetroPluginOptions = require("./getViteMetroPluginOptions");
var import_loadConfig = require("../vite/loadConfig");
async function loadUserViteMetroOptions(projectRoot) {
  var previousCwd = process.cwd();
  var previousIsVxrnCli = process.env.IS_VXRN_CLI;
  try {
    process.chdir(projectRoot);
    process.env.IS_VXRN_CLI = "true";
    return await (0, import_loadConfig.loadUserOneOptions)("build", true);
  } finally {
    process.chdir(previousCwd);
    if (previousIsVxrnCli === void 0) {
      delete process.env.IS_VXRN_CLI;
    } else {
      process.env.IS_VXRN_CLI = previousIsVxrnCli;
    }
  }
}
async function withOne(baseConfigOrProjectRoot) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options_projectRoot, _ref, _options_routerRoot, _ref1;
  var _loaded_config, _loaded_config_config, _loaded_config1;
  var projectRoot = import_path.default.resolve(typeof baseConfigOrProjectRoot === "string" ? baseConfigOrProjectRoot : (_options_projectRoot = options.projectRoot) !== null && _options_projectRoot !== void 0 ? _options_projectRoot : process.cwd());
  var loaded = options.loadViteConfig === false ? void 0 : await loadUserViteMetroOptions(projectRoot);
  var metroPluginOptions = (_ref = loaded === null || loaded === void 0 ? void 0 : loaded.metroOptions) !== null && _ref !== void 0 ? _ref : (0, import_getViteMetroPluginOptions.getViteMetroPluginOptions)({
    projectRoot,
    relativeRouterRoot: (_options_routerRoot = options.routerRoot) !== null && _options_routerRoot !== void 0 ? _options_routerRoot : "app",
    ignoredRouteFiles: options.ignoredRouteFiles,
    linking: options.linking,
    setupFile: options.setupFile
  });
  var viteConfig = {
    ...loaded === null || loaded === void 0 ? void 0 : (_loaded_config = loaded.config) === null || _loaded_config === void 0 ? void 0 : _loaded_config.config,
    root: import_path.default.resolve((_ref1 = loaded === null || loaded === void 0 ? void 0 : (_loaded_config1 = loaded.config) === null || _loaded_config1 === void 0 ? void 0 : (_loaded_config_config = _loaded_config1.config) === null || _loaded_config_config === void 0 ? void 0 : _loaded_config_config.root) !== null && _ref1 !== void 0 ? _ref1 : projectRoot)
  };
  var { defaultConfig } = await (0, import_vite_plugin_metro.buildMetroConfigInputFromViteConfig)(viteConfig, {
    ...metroPluginOptions,
    mainModuleName: "one/metro-entry"
  });
  return defaultConfig;
}
var withOne_default = withOne;
//# sourceMappingURL=withOne.js.map
